import "./UsageTypeStatisic.scss";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useMemo } from "react";
import { useRef } from "react";

import { Box } from "@mui/material";

import ReactECharts from "echarts-for-react";

import { fetchUsageType } from "../../slices/transportStatistic";

const mapToPieDataWithOther = (obj = {}, limit = 12) => {
    const entries = Object.entries(obj)
        .map(([k, v]) => [k, Number(v) || 0])
        .sort((a, b) => b[1] - a[1]);

    const top = entries.slice(0, limit);
    const other = entries.slice(limit).reduce((s, [, v]) => s + v, 0);

    const result = top.map(([name, value]) => ({ name, value }));
    if (other > 0) result.push({ name: "Остальное", value: other });

    return result;
};

const UsageTypeStatistic = ({ params }) => {
    const dispatch = useDispatch();
    const token = useSelector((s) => s.auth.token?.data?.token || s.auth.token);
    const dataMap = useSelector((s) => s.transportStatistic.usageType);
    const chartRef = useRef(null);

    useEffect(() => {
        dispatch(fetchUsageType({ token, params }));
    }, [dispatch, token, params]);

    useEffect(() => {
        const t = setTimeout(() => {
            chartRef.current?.getEchartsInstance().resize();
        }, 120);
        return () => clearTimeout(t);
    }, [dataMap]);

    const pieData = useMemo(() => mapToPieDataWithOther(dataMap, 12), [dataMap]);

    const options = {
        title: { text: "Тип использования", left: "center" },
        tooltip: {
            trigger: "item",
            formatter: ({ name, value, percent }) =>
                `${name}<br/>${value} (${percent}%)`,
        },
        legend: { bottom: 0, type: "scroll" },
        series: [
            {
                name: "Тип использования",
                type: "pie",
                radius: ["40%", "70%"],
                avoidLabelOverlap: true,
                itemStyle: {
                    borderRadius: 6,
                    borderColor: "#fff",
                    borderWidth: 2,
                },
                label: { show: false },
                emphasis: {
                    label: { show: true, fontSize: 14, fontWeight: 600 },
                },
                data: pieData,
            },
        ],
    };

    return (
        <Box className="usage_type_statistic">
            <ReactECharts
                ref={chartRef}
                option={options}
                style={{ width: "100%", height: "100%" }}
            />
        </Box>
    );
};

export default UsageTypeStatistic;